import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  query: gql`
    query limitGroups {
      limitGroups {
        id
        name
      }
    }
  `,
  config: {
    skip: (ownProps) => ownProps.skip,
    options: () => ({
      errorPolicy: "none",
    }),
  },
  propTypes: {
    skip: PropTypes.bool,
  },
  isLoaded: (data) => {
    return !!data.limitGroups;
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/limitGroups.js